import { render } from "./AuthenticateUser.vue?vue&type=template&id=3b87ef26&scoped=true"
import script from "./AuthenticateUser.vue?vue&type=script&lang=js"
export * from "./AuthenticateUser.vue?vue&type=script&lang=js"

import "./AuthenticateUser.vue?vue&type=style&index=0&id=3b87ef26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b87ef26"]])

export default __exports__